<template>
  <v-card width="390">
    <v-flex d-flex>
      <v-flex d-inline-flex align-baseline xs6 pt-3>
        <v-flex class="text-xs-right" pl-2>
          <v-icon v-if="alarm.isJustified === null">chat_bubble</v-icon>
          <v-icon v-else-if="alarm.isJustified">message</v-icon>
          <v-icon v-else-if="alarm.isJustified === false">report_off</v-icon>
        </v-flex>
        <v-flex>
          <h2 class="pt-2 px-3">Justificación</h2>
        </v-flex>
      </v-flex>
      <v-flex xs6 class="close-btn" pt-1>
        <v-btn
          color="primary"
          depressed
          small
          fab
          :disabled="disabledCancel"
          @click="cancel"
        >
          <v-icon>clear</v-icon>
        </v-btn>
      </v-flex>
    </v-flex>
    <!-- UNREPORTED -->
    <v-flex v-if="alarm.type === 'unreported_event_alarms'" pt-2 px-3>
      <h4>Vehículos Operativos sin Reporte en 72 Horas</h4>
    </v-flex>
    <!-- MOVEMENT -->
    <v-flex v-if="alarm.type === 'movement'" pt-2 px-3>
      <h4>En Movimiento sin Autorización</h4>
    </v-flex>
    <!-- MISSION -->
    <v-flex v-if="alarm.type === 'mission'" pt-2 px-3>
      <h4>{{ alarm.alarmName }}</h4>
      <h4>{{ alarm.alarmDescription }}</h4>
      <!-- MANUAL RELOAD REMEMBER MESSAGE -->
      <v-flex
        v-if="alarmsPendingToManualReload"
        class="message-reload-pending"
        pl-3
        my-1
      >
        <v-flex d-inline-flex align-center>
          <v-flex>
            <v-icon left color="grey darken-3">warning</v-icon>
          </v-flex>
          <v-flex class="caption font-weight-medium">
            Recuerde que la información de Alarmas ha cambiado, por eso se recomienda hacer click en el botón recargar:
          </v-flex>
          <v-flex>
            <v-btn
              flat
              icon
              color="grey darken-3"
              @click="fetchMissionAlarmsInJustification"
            >
              <v-icon>replay</v-icon>
            </v-btn>
          </v-flex>
        </v-flex>
      </v-flex>
    </v-flex>
    <!-- SPEED -->
    <v-flex v-if="alarm.type === 'speed'" pt-2 px-3>
      <h4>Exceso de Velocidad</h4>
    </v-flex>
    <!-- PARKING -->
    <v-flex v-if="alarm.type === 'parking'" pt-2 px-3>
      <h4>Estacionarias (Minuta de Servicio)</h4>
    </v-flex>
    <!-- VEHICLE INFO -->
    <v-flex px-3 pt-3>
      <h3>Vehículo</h3>
      <v-flex d-flex>
        <v-flex 
          class="caption font-weight-bold"
        >
          Placa
        </v-flex>
        <v-flex
          class="caption font-weight-bold"
        >
          Código/Sigla
        </v-flex>
      </v-flex>
      <v-flex d-flex>
        <v-flex>
          {{ alarm.licensePlate }}
        </v-flex>
        <v-flex>
          {{ alarm.code }}
        </v-flex>
      </v-flex>
    </v-flex>
   
    <v-divider class="mx-3 mt-2 mb-1"></v-divider>
    <!-- NULL -->
    <v-flex
      v-if="alarm.isJustified === null"
      py-2
      px-3
    >
      <h3>Comportamiento justificado?</h3>
      <v-radio-group
        v-model="isJustifiedOption"
        row
        :disabled="disabledCancel"
        @change="changeAction"
      >
        <v-radio
          label="Si"
          value="si"
        ></v-radio>
        <v-radio
          label="No"
          value="no"
        ></v-radio>
      </v-radio-group>
      <v-textarea
        v-if="isJustifiedOption !== null"
        v-model="observationInput"
        box
        name="observations"
        label="Justificación"
        :disabled="disabledCancel"
        @input="textInputAction"
      ></v-textarea>
      <v-flex
        v-if="isJustifiedOption !== null"
        d-flex
      >
        <v-btn
          color="error"
          :disabled="disabledCancel"
          @click="cancel"
        >
          <v-icon left>close</v-icon>
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          :disabled="justificationComputed"
          :loading="$loading.isLoading('justificationAlarm')"
          @click="sendJustification"
        >
          <v-icon left>cloud_upload</v-icon>
          Guardar
        </v-btn>
      </v-flex>
    </v-flex>
    <!-- TRUE OR FALSE-->
    <v-flex
      v-else
      py-2
      px-3
    >
      <h3>{{ `Comportamiento justificado: ${alarm.isJustified ? 'Si' : 'No'}` }}</h3>
      <v-flex my-1>
        <h3>Justificación:</h3>
      </v-flex>
      <v-flex mb-2>
        {{ alarm.observations }}
      </v-flex>
    </v-flex>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { dataBaseAlarmsMap } from '../utils/genericAlarms'

export default {
  name: 'justification-alert',
  props: {
    alarm: {
      type: Object,
      required: true
    },
    alarmsPendingToManualReload: {
      type: Boolean,
      required: false
    }

  },
  data() {
    return {
      typingDelay: false,
      disabledCancel: false,
      isJustifiedOption: null,
      observationInput: ''
    }
  },
  computed: {
    ...mapGetters(['pusherRef']),
    ...mapGetters({
      user: 'auth/getProfile'
    }),
    justificationComputed() {
      let result = true
      if (this.isJustifiedOption !== null && this.observationInput !== '') result = false
      return result
    }
  },
  methods: {
    ...mapActions(['justificationGeneralAlarm', 'justificationAlarm']),
    triggerNotification() {
      const channel = this.pusherRef.channels.channels['presence-justification-in-progress']
      channel.trigger(
        'client-justification-in-progress',
        {
          i: this.alarm.alarmId,
          a: this.alarm.alarmName,
          d: this.alarm.alarmDescription,
          v: true,
          u: this.user.name
        }
      )
    },
    textInputAction() {
      if (!this.typingDelay) {
        this.triggerNotification()
        this.typingDelay = true
        setTimeout(() => {
          this.typingDelay = false
        }, 2000)
      }
    },
    changeAction() {
      this.triggerNotification()
    },
    async sendJustification() {
      this.disabledCancel = true
      const data = {
        alarmId: this.alarm.alarmId,
        isJustified: null
      }

      data.isJustified = this.isJustifiedOption === 'si'
      data.observations = this.observationInput

      let result
      if (this.alarm.type === 'mission') result = await this.justificationAlarm(data)
      else {
        data.justifiableType = dataBaseAlarmsMap.get(this.alarm.type)
        result = await this.justificationGeneralAlarm(data)
      }
      // console.log('SEND JUSTIFICATION RESULT:', result)
      if (result.status === 200 || result.status === 201) this.cancel()
      else if (result.status === 409) {
        // console.log('RESULT 409', result)
        this.cancel()
        this.$emit('showMessage', result.data)
      } else console.error('ERROR SJ', result)
    },
    cancel() {
      if (this.alarm.isJustified === null) {
        let data = {}
        switch (this.alarm.type) {
          case 'movement':
            data = {
              i: this.alarm.alarmId,
              t: 'movement',
              v: false,
              u: ''
            }
            break
          case 'mission':
            data = {
              i: this.alarm.alarmId,
              a: this.alarm.alarmName,
              d: this.alarm.alarmDescription,
              t: 'mission',
              v: false,
              u: ''
            }
            break
          case 'speed':
            data = {
              i: this.alarm.alarmId,
              vi: this.alarm.vehicleId,
              t: 'speed',
              v: false,
              u: ''
            }
            break
          case 'unreported':
            data = {
              i: this.alarm.alarmId,
              t: 'unreported',
              v: false,
              u: ''
            }
            break
          case 'parking':
            data = {
              i: this.alarm.alarmId,
              t: 'parking',
              v: false,
              u: ''
            }
            break
          case 'geofenceIn':
            data = {
              i: this.alarm.alarmId,
              a: this.alarm.alarmName,
              d: this.alarm.alarmDescription,
              t: 'geofenceIn',
              v: false,
              u: ''
            }
            break
          default:
            break
        }
        const channel = this.pusherRef.channels.channels['presence-justification-in-progress']
        channel.trigger('client-justification-in-progress', data)
      }
      this.disabledCancel = false
      this.isJustifiedOption = null
      this.observationInput = ''
      this.$emit('showDialog')
    },
    fetchMissionAlarmsInJustification() {
      this.cancel()
      this.$emit('fetchMissionAlarmsIn')
    }
  }
}
</script>

<style lang="stylus" scoped>
.close-btn
  text-align right

.message-reload-pending
  color #424242
  background-color #FFB300
  border-radius 3px
  max-width 340px
  height 45px
  line-height 11px
</style>


// WEBPACK FOOTER //
// src/components/JustificationAlert.vue